windowSize.$inject = [];

/**
 * @ngdoc    object
 * @module   csm.ui.tools
 * @name     csm.ui.tools.type:WindowSize
 *
 * @description
 * Utility for getting information about the window size. This will also include
 * flags to indicate bootstrap window sizes (xs/sm/md/lg).
 *******************************************************************************/
/* @ngInject */ export function windowSize() {
  /*-----------------------*/
  /* Window size accessors */
  /*-----------------------*/
  function height() {
    return window.innerHeight;
  }
  function width() {
    return window.innerWidth;
  }

  /*******************************************************************************
   * widthBound */
  /**
   * Returns a boolean indication if the width meets the provided bounds definition.
   *
   * @param   bounds  Bounds definition object
   * @returns         Boolean indication that bound limits are met
   *******************************************************************************/
  function widthBound(bounds) {
    var w = width();
    var lowerValid = isNaN(bounds.lower) || w >= bounds.lower;
    var upperValid = isNaN(bounds.upper) || w < bounds.upper;
    return lowerValid && upperValid;
  }

  /** Bootstrap Window Size Bounds. */
  var BS_BOUNDS = {
    xs: { lower: NaN, upper: 768 },
    sm: { lower: 768, upper: 992 },
    md: { lower: 992, upper: 1200 },
    lg: { lower: 1200, upper: NaN }
  };
  var obj = {};

  /**
   * @ngdoc      property
   * @name       height
   * @propertyOf csm.ui.tools.type:WindowSize
   * @returns   {Number} Pixel height of the window
   */
  Object.defineProperty(obj, 'height', { get: height });

  /**
   * @ngdoc      property
   * @name       width
   * @propertyOf csm.ui.tools.type:WindowSize
   * @returns   {Number} Pixel width of the window
   */
  Object.defineProperty(obj, 'width', { get: width });

  /**
   * @ngdoc      property
   * @name       isXS
   * @propertyOf csm.ui.tools.type:WindowSize
   * @returns    {Boolean} Indication that the window corresponds to bootstrap's xs bounds
   */
  Object.defineProperty(obj, 'isXS', {
    get: function () {
      return widthBound(BS_BOUNDS.xs);
    }
  });

  /**
   * @ngdoc      property
   * @name       isSM
   * @propertyOf csm.ui.tools.type:WindowSize
   * @returns    {Boolean} Indication that the window corresponds to bootstrap's sm bounds
   */
  Object.defineProperty(obj, 'isSM', {
    get: function () {
      return widthBound(BS_BOUNDS.sm);
    }
  });

  /**
   * @ngdoc      property
   * @name       isMD
   * @propertyOf csm.ui.tools.type:WindowSize
   * @returns    {Boolean} Indication that the window corresponds to bootstrap's md bounds
   */
  Object.defineProperty(obj, 'isMD', {
    get: function () {
      return widthBound(BS_BOUNDS.md);
    }
  });

  /**
   * @ngdoc      property
   * @name       isLG
   * @propertyOf csm.ui.tools.type:WindowSize
   * @returns    {Boolean} Indication that the window corresponds to bootstrap's lg bounds
   */
  Object.defineProperty(obj, 'isLG', {
    get: function () {
      return widthBound(BS_BOUNDS.lg);
    }
  });

  return obj;
}
